import { ILocationFilterProps } from 'components/LocationFilterInput/LocationFilterInput.types';
import { ISSFBehaviorsOptions } from 'hooks/useSSFBehaviors/useSSFBehaviors.types';
import { DateTime } from 'luxon';
import { createApolloClient } from 'providers/ApolloProvider';
import { QUERY_weeklyDashboardOverview } from 'queries';
import { WeeklyDashboardOverviewQuery } from 'types/graphql';

const client = createApolloClient();

/* eslint-disable @typescript-eslint/no-explicit-any */
function payloadTransformer(variables: Record<string, any>) {
  const communityId = Number(variables.location.value);
  return {
    communityId,
  };
}

export const weeklyOverviewQueryConfig = ({
  location,
}: {
  location: ILocationFilterProps['value'];
}): ISSFBehaviorsOptions => ({
  key: 'WEEKLY_OVERVIEW',
  query: QUERY_weeklyDashboardOverview,
  client,
  payloadTransformer,
  responseTransformer: (data: WeeklyDashboardOverviewQuery) => {
    if (!data?.dashboardWeeklyOverview) {
      return {
        pendingOrders: '',
        pendingOrdersToday: '',
        fulfillmentRate: '',
        fulfillmentRateChange: '',
        agencySpent: '',
        agencySpentChange: '',
        weeklyOvertimeHours: '',
        weeklyOvertimeHoursChange: '',
        dailyOvertimeHours: '',
      };
    }
    return data.dashboardWeeklyOverview;
  },
  variables: {
    communityId: Number(location.value),
  },
  schema: {
    location: {
      initialValue: location.value,
      isGlobalCached: true,
      isPreservedOnReset: false,
    },
  },
});

export function formatWeekRange(startDate: string, endDate: string) {
  if (!startDate || !endDate) {
    return '';
  }
  const start = DateTime.fromISO(startDate);
  const end = DateTime.fromISO(endDate);
  if (start.month === end.month && start.year === end.year) {
    return `${start.toFormat('LLLL d')} - ${end.toFormat('d, yyyy')}`;
  } else {
    return `${start.toFormat('LLLL d')} - ${end.toFormat('LLLL d, yyyy')}`;
  }
}
